import React from "react";
import { Button } from "@mui/material";
// import { AllowedValuesDTO } from "api";

import { buttonStyle } from "./styles";
import { LabelWithButtonProps } from "./types";
// import { AddCollectorButton } from "../document-summary-v2/utility-bill/utility-bill-form-view/components";

export const RenderLabelWithButton = ({
  label,
  onClickOtherSites,
  siteId,
  // isEmpty,
  // allowedValues,
  // siteData,
  // generatedCollectorsColumns,
  // setNewSite,
}: LabelWithButtonProps) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <span>{label}</span>
    <Button
      sx={buttonStyle}
      variant="contained"
      color="primary"
      onClick={onClickOtherSites}
    >
      {siteId === 0 || siteId === -1 || siteId === undefined ? "Other Sites" : "Change"}
    </Button>
    {/* {isEmpty && <AddCollectorButton
      buttonsStyle={buttonStyle}
      allowedValues={allowedValues || ({} as AllowedValuesDTO)}
      editCollector={siteData}
      columns={generatedCollectorsColumns}
      setNewSite={setNewSite}
    />} */}
  </div>
);
